<template>
  <div class="app-input-number" :class="{'el-form--inline': dialogName}">
    <div v-if="optionPrefix">{{optionPrefix}}</div>
    <span
      :class="{show_clear: showClear}"
      @mouseenter="onMouseenter"
      @mouseleave="onMouseleave">
      <el-input-number
        ref="input"
        class="app-input-number-inner"
        v-model.number="model"
        :placeholder="placeholder"
        :precision="precision"
        :min="min"
        :max="max"
        :disabled="computedDisabled"
        :class="optionClass"
        @keydown.enter.native="onEnterKey($event)"
        @focus="onFocus"
        @blur="onBlur"
        @change="onChange">
        </el-input-number>
      <i class="app-clear-button el-input__icon el-icon-circle-close" @click="onClearButtonClicked"></i>
    </span>
    <!-- ダイアログ表示ボタン -->
    <app-button-search-dialog v-if="dialogName" @click="$emit('app-event', 'dialog:' + dialogName)" :disabled="disabled"></app-button-search-dialog>
    <!-- /ダイアログ表示ボタン -->
    <div v-if="optionSuffix">{{optionSuffix}}</div>
  </div>
</template>

<style>
div.app-input-number > div {
  display: inline-block;
}

.app-input-number-inner .el-input-number__decrease,
.app-input-number-inner .el-input-number__increase {
  display: none;
}
.app-input-number-inner .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
}

.app-clear-button {
  display: none;

  position: absolute;
  top: 0;
  left: 5px;
  cursor: pointer;
  color: #C0C4CC;
}
.app-clear-button:hover {
  color: #000;
}
.show_clear .app-clear-button {
  display: block;
}

.el-input-number--small {
  width: 100%;
}

.app-input-number-inner.mini {
  max-width: 55px;
}
.app-input-number-inner.short {
  max-width: 110px;
}
.app-input-number-inner.medium {
  max-width: 165px;
}
.app-input-number-inner.long {
  max-width: 300px;
}
</style>

<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppInputComponent from './AppInputComponent';

@Component
export default class AppInputNumber extends AppInputComponent {
  data () {
    return {
      hovering: false,
      focused: false,
      ready: false
    }
  }

  get min () {
    return (this.options && 'min' in this.options) ? this.options.min : undefined;
  }

  get max () {
    return (this.options && 'max' in this.options) ? this.options.max : undefined;
  }

  get precision () {
    return (this.options && 'precision' in this.options) ? this.options.precision : 0;
  }

  /**
   * v-model対応
   */
  get model () {
    // el-input-numberによって null が 0 に変換されてしまう為 undefined を返却する
    return (this.value === null) ? undefined : this.value;
  }

  /**
   * v-model対応
   */
  set model (value) {
    // undefined については null に変換する
    this.$emit('input', (typeof value === 'undefined') ? null : value);
  }

  /**
   * デフォルトサイズ
   */
  get defaultSize () {
    return 'medium';
  }

  // 親コンポーネントへの透過イベント
  onChange (...args) {
    this.$emit('app-event', 'change', this, ...args);

    // 値が変更されたタイミングでバリデーションを要求する
    this.$emit('app-event', 'require:validate', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onFocus (...args) {
    // スマホでは不便な動作となるので無効化
    // フォーカスを取得した時点でテキストを選択状態にする
    // if (this.$refs.input && this.$refs.input.select) {
    //   this.$refs.input.select();
    // }

    this.focused = true;
    this.$emit('app-event', 'focus', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onBlur (...args) {
    this.focused = false;
    this.$emit('app-event', 'blur', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onMouseenter (...args) {
    this.hovering = true;
    this.$emit('app-event', 'mouseenter', this, ...args);
  }

  // 親コンポーネントへの透過イベント
  onMouseleave (...args) {
    this.hovering = false;
    this.$emit('app-event', 'mouseleave', this, ...args);
  }

  mounted () {
    try {
      // 子のDOM要素を補正してautofocus属性を追加する
      // this.$refs.input.$el.getElementsByTagName('input')[0].setAttribute('autofocus', 'autofocus');
    } catch (e) {}
  }

  // クリア処理
  onClearButtonClicked () {
    this.model = null;
    this.focus();
  }

  // クリアボタン表示制御
  get showClear () {
    // this.$refs.input の有無で判定を行うと（あとからObjectが追加されるので）watch対象とならない。
    // そのため、参照可能になったか否かを判定するためのthis.initializedのフラグを参照するようにしています。
    // userInputは入力値、currentValueはモデル値が返却される、
    // 編集状態になるまではuserInputはnull値となるので、currentValueを参照します。
    const value = (this.ready) ? ((this.$refs.input.userInput !== null) ? this.$refs.input.userInput : this.$refs.input.currentValue) : null;
    const hasInputValue = (value !== null && value !== undefined && value !== '');
    return this.clearable && !this.disabled && !this.readonly && hasInputValue && (this.focused || this.hovering);
  }

  // ボタン押下時のイベント名
  get dialogName () {
    return (this.options && 'dialogName' in this.options) ? this.options.dialogName : '';
  }

  initialize () {
    this.ready = true;
  }

  // エンターキーイベント
  onEnterKey (event) {
    // el-input-numberの場合modelに反映されるまで待機が必要
    this.$nextTick().then(() => {
      this.$emit('app-event', 'enterkey', event, this);
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/input/AppInputNumber.vue